// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__c2vLr","inputWrap":"styles_inputWrap__1njvh","input":"styles_input__N0R9_"};